import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api';

function initialState () {
  return {
    list: [],
    purchases: [],
  };
}

const state = initialState ();

// actions

const actions = {
  async createGroupPricing (context, payload) {
    var response = await API.monetization.createGroupPricing (payload);
    return response;
  },

  async updateGroupPricing (context, payload) {
    var response = await API.monetization.updateGroupPricing (payload);
    context.dispatch ('listPricing', payload);
    return response;
  },

  async getPricing (context, payload) {
    var response = await API.monetization.getPricing (payload);
    return response.pricing;
  },

  async listPricing (context, payload) {
    var response = await API.monetization.listPricing (payload);
    context.commit ('set_list', response);
    return response;
  },

  async listPurchases (context, payload) {
    var response = await API.monetization.listPurchases (payload);
    context.commit ('set_purchases', response);
    return response;
  },

  async getPurchase (context, payload) {
    var purchase = context.getters['getPurchase'] (payload.purchase_id);
    if (!purchase) {
      var response = await API.monetization.getPurchase (payload);
      purchase = response.purchase;
    }
    return purchase;
  },

  // Get all screenings related to a pricing plan
  async getPricingScreenings (context, payload) {
    var response = await API.monetization.getPricingScreenings (payload);
    return response.screenings;
  },

  async exportAllPurchases (context, payload) {
    var response = await API.monetization.exportAllPurchases (payload);
    return response;
  },


  async listPayouts (context, payload) {
    var response = await API.monetization.listPayouts (payload);
    return response;
  },

  async addPayout (context, payload) {
    var response = await API.monetization.addPayout (payload);
    if(response.purchase){
      await context.commit ('update_purchase', response)
    }
    return response;
  },

  async removePayout (context, payload) {
    var response = await API.monetization.removePayout (payload);
    await context.commit ('update_purchase', response)
    return response;
  },

  async updatePayoutRequest (context, payload) {
    var response = await API.monetization.updatePayoutRequest (payload);
    return response;
  }
};

// getters
const getters = {
  getPricing: state => pricing_id => {
    var pricing = null;
    if (state.list.length) {
      pricing = state.list.find (pricing => {
        return pricing.id == pricing_id;
      });
    }
    return pricing;
  },

  getPurchase: state => purchase_id => {
    var result = null;
    if (state.purchases.length) {
      result = state.purchases.find (purchase => {
        return purchase.id == purchase_id;
      });
    }
    return result;
  },
};

// mutations
const mutations = {
  updateField,
  set_list (state, payload) {
    state.list = payload.pricing.data;
  },
  set_purchases (state, payload) {
    state.purchases = payload.purchases.data;
  },
  update_purchase (state, payload) {
    state.purchases = [
      ...state.purchases.filter (
        purchase => purchase.id !== payload.purchase.id
      ),
      payload.purchase,
    ];
  },
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
